import { Button, Grid, Typography } from "@mui/material";
import { Fragment, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Modal } from "@common/Modal/Modal";
import { UpdateUserEmail } from "./UpdateUserEmail";

interface IParams {
    email: string;
}

export const UserEmail = (props: IParams) => {
    const [isEditing, setIsEditing] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { t } = useTranslation("profile");
    const { email } = props;

    const onFinishUpdate = () => {
        setIsEditing(false);
        setIsModalOpen(true);
    };

    const closeModal = () => setIsModalOpen(false);

    return isEditing ? (
        <UpdateUserEmail
            handleCancelClick={() => setIsEditing(false)}
            oldEmail={email}
            onFinishUpdate={onFinishUpdate}
        />
    ) : (
        <Fragment>
            <Modal close={closeModal} confirm={closeModal} isModalOpen={isModalOpen} title={t("emailSuccess")}>
                <Typography align="center" variant="normal">
                    <Trans i18nKey="emailChange" ns="profile" />
                </Typography>
            </Modal>
            <Grid alignItems="flex-end" className="mydetail__fields" container>
                <Grid item md={4} xs={9}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography color="textSecondary" id="detailEmail" variant="small">
                                {t("email")}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography aria-labelledby="detailEmail" noWrap variant="normal">
                                {email}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item sm={2} xs={3}>
                    <Button
                        color="secondary"
                        fullWidth
                        size="large"
                        type="button"
                        variant="contained"
                        onClick={() => setIsEditing(true)}
                    >
                        {t("update")}
                    </Button>
                </Grid>
            </Grid>
        </Fragment>
    );
};
